import styled from '@emotion/styled';

const TopNavItemDivider = styled.li(({ theme }) => ({
	display: 'inline-block',
	verticalAlign: 'top',
	height: '100%',
	position: 'relative',
	'&:before': {
		content: '""',
		position: 'absolute',
		width: 1,
		left: -0.5,
		top: 15.5,
		bottom: 15.5,
		backgroundColor: theme.colors.brandGrayMedium,
		opacity: 1,
		height: '40px',
	},
}));

export default TopNavItemDivider;
